(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hv-catalog-shortcuts"] && !Shopify.designMode) return;
  try {
    (() => {
  function syncCatalogLinks() {
    const root = document.querySelector('.hv-catalog');
    if (!root) return;
    const url = new URL(window.location.href);
    const hasChoice = [...url.searchParams.keys()].some(key => key.startsWith('filter.') || ['sort_by', 'page', 'view'].includes(key));
    const defaults = root.querySelector('[data-hv-default-catalog="true"]');
    if (defaults && !hasChoice && !window.Shopify?.designMode) {
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.set('sort_by', 'created-descending');
      window.location.replace(url.toString());
      return;
    }
    const availability = url.searchParams.getAll('filter.v.availability');
    const available = availability.length === 1 && availability[0] === '1';
    const sort = url.searchParams.get('sort_by');
    let current = available && sort === 'created-descending' ? 'new' : available && sort === 'best-selling' ? 'available' : null;
    if (!available && ![...url.searchParams.keys()].some(key => key.startsWith('filter.')) && sort === 'created-descending') current = 'all';
    root.querySelectorAll('[data-hv-browse]').forEach(link => {
      if (link.dataset.hvBrowse === current) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCatalogLinks);
  else syncCatalogLinks();
  window.addEventListener('popstate', syncCatalogLinks);
  document.addEventListener('shopify:section:load', syncCatalogLinks);
  const container = document.getElementById('ProductGridContainer');
  if (container) new MutationObserver(syncCatalogLinks).observe(container, {childList:true});
})();
  } catch(e) { console.error(e); }
})();

})();
